<template>
  <div class="mic-container">
    <div class="circle" :class="{'active': active}" @click="recording">
      <i class="fas fa-microphone"></i>
    </div>

    <div class="holder trash-container">
      <audio ref="audioPlayer" controls style="display: none; margin-right: 10px;"></audio>
      <div id="trash" class="trash-container"  hidden>
        <button id="trash-button" class="btn btn-danger" @click.stop="removeAudioPlayer" >
          <i class="fas fa-trash"></i>
        </button>
      </div>
      <div id="send"class="send-container" hidden>
          <button id="send-button" class="btn btn-success" @click="sendAudioOnButtonClick">
          <i class="fa-solid fa-paper-plane"></i>
        </button>
      </div>
      <div data-role="recordings"></div>
    </div>
  </div>
</template>
<script>
import { mapActions } from "vuex";
export default {
  data(){
    return {
      active: false,
      showAudioPlayer: true,
      audioBlob: null,
      myRecorder: {
        objects: {
          context: null,
          stream: null,
          recorder: null
        }
      }
    }    
  },
  methods: {
  ...mapActions(["sendAudio"]),
  recording() {
    this.active = !this.active;

    this.init();

    var listObject = $('[data-role="recordings"]');
    var buttonState = !!$(this).attr("data-recording");

    if (!buttonState) {
      $(this).attr("data-recording", "true");
      this.start();
    } else {
      $(this).attr("data-recording", "");
      this.stop(listObject);
    }
  },
  init: function () {
    if (null === this.myRecorder.objects.context) {
      this.myRecorder.objects.context = new (
        window.AudioContext || window.webkitAudioContext
      );
    }
  },
  start() {
    const self = this;
    var options = { audio: true, video: false };

    navigator.mediaDevices.getUserMedia(options).then(function (stream) {
      self.myRecorder.objects.stream = stream;
      self.myRecorder.objects.recorder = new Recorder(
        self.myRecorder.objects.context.createMediaStreamSource(stream),
        { numChannels: 1 }
      );
      self.myRecorder.objects.recorder.record();
    }).catch(function (err) {
      console.log("Error: ", err);
    });
  },
  stop(listObject) {
    console.log("compilado...")
    const self = this;
    if (null !== this.myRecorder.objects.stream) {
      this.myRecorder.objects.stream.getAudioTracks()[0].stop();
    }
    if (null !== this.myRecorder.objects.recorder) {
      this.myRecorder.objects.recorder.stop();

      if (null !== listObject && "object" === typeof listObject && listObject.length > 0) {
        this.myRecorder.objects.recorder.exportWAV(async function (blob) {
          self.audioBlob = blob;
          self.$emit('audio-recorded', blob);
          self.$refs.audioPlayer.src = URL.createObjectURL(blob);
          self.$refs.audioPlayer.style.display = self.showAudioPlayer ? "block" : "none";
          const trashElement = document.getElementById('trash');
          const sendElement = document.getElementById('send');
          if (trashElement) trashElement.removeAttribute('hidden');
          if (sendElement) sendElement.removeAttribute('hidden');
        }, "audio/mpeg");
      }
    }
  },
  sendAudioOnButtonClick() {
    if (this.audioBlob) {
        // ✅ Passa o blob dentro do objeto esperado pela action
        this.sendAudio({ blob: this.audioBlob, queueMessage: null });

        this.audioBlob = null;
        this.hideButtons();
        this.removeAudioPlayer();
    }
    },
    removeAudioPlayer() {
      const audioPlayerElement = this.$refs.audioPlayer;
      audioPlayerElement.style.display = 'none';

      this.hideButtons();
    },

    hideButtons() {
      const trashElement = document.getElementById('trash');
      const sendElement = document.getElementById('send');
      if (trashElement) trashElement.setAttribute('hidden', true);
      if (sendElement) sendElement.setAttribute('hidden', true);
    },
}
}
</script>

<style scoped>
body {
overflow: hidden;
}
.trash-container {
display: flex;
align-items: center;
justify-content: center;
margin-right:1em;
}
.trash-container .circle {
width: 40px;
height: 40px;
border-radius: 50%;
background: #ffffff;
display: flex;
justify-content: center;
align-items: center;
z-index: 1;
transition: 0.5s;
box-shadow: 0 6px 10px 0 rgba(0, 0, 0, 0.14), 0 1px 18px 0 rgba(0, 0, 0, 0.12), 0 3px 5px -1px rgba(0, 0, 0, 0.2);
}
.trash-container .circle i {
color: #b2b1b1;
font-size: 23px;
transition: 0.9s;
}
.trash-container .circle:before {
content: '';
width: 40px;
height: 40px;
border-radius: 50%;
opacity: 0.2;
z-index: -1;
position: absolute;
}
.mic-container {
display: flex;
align-items: center;
justify-content: center;
margin-right:1em;
}
.mic-container .circle {
width: 40px;
height: 40px;
border-radius: 50%;
background: #ffffff;
display: flex;
justify-content: center;
align-items: center;
z-index: 1;
transition: 0.5s;
box-shadow: 0 6px 10px 0 rgba(0, 0, 0, 0.14), 0 1px 18px 0 rgba(0, 0, 0, 0.12), 0 3px 5px -1px rgba(0, 0, 0, 0.2);
}
.mic-container .circle i {
color: #b2b1b1;
font-size: 23px;
transition: 0.9s;
}
.mic-container .circle:before {
content: '';
width: 40px;
height: 40px;
border-radius: 50%;
opacity: 0.2;
z-index: -1;
position: absolute;
}
.mic-container .circle.active {
background: #ff0000;
}
.mic-container .circle.active:before {
background: gray;
animation: bounce 0.8s ease-in-out infinite 0.5s;
}
.mic-container .circle.active i {
color: #ffffff;
}

.holder{
  display: flex;
  margin-left: 10px;
}
#trash-button{
  color: white;
  background-color: #1c869a;
  border-radius: 20px !important;
  border: transparent;
  padding: 0px 10px;
  height: 35px;
  align-self: center;
  background-color: #dc3545;
  transition: background-color 0.3s ease;
  box-shadow: 0 6px 10px 0 rgb(0 0 0 / 14%), 0 1px 18px 0 rgb(0 0 0 / 12%), 0 3px 5px -1px rgb(0 0 0 / 20%);
}
#trash-button:hover{
  color: white;
  background-color: #c82333;
  transition: 0.3s;
}
#send-button{
  color: white;
  border-radius: 20px !important;
  border: transparent;
  padding: 0px 10px;
  height: 35px;
  align-self: center;
  background-color: #28a745;
  transition: background-color 0.3s ease;
  box-shadow: 0 6px 10px 0 rgb(0 0 0 / 14%), 0 1px 18px 0 rgb(0 0 0 / 12%), 0 3px 5px -1px rgb(0 0 0 / 20%);
}
#send-button:hover{
  color: white;
  background-color: #218838;
  transition: 0.3s;
}
.send-container{
  margin-left: -10px;
}
.trash-container{
  margin-left: 10px;
}
.trash-container .circle-send {
width: 40px;
height: 40px;
border-radius: 50%;
background: green;
display: flex;
justify-content: center;
align-items: center;
z-index: 1;
transition: 0.5s;
box-shadow: 0 6px 10px 0 rgba(0, 0, 0, 0.14), 0 1px 18px 0 rgba(0, 0, 0, 0.12), 0 3px 5px -1px rgba(0, 0, 0, 0.2);
}
.trash-container .circle-send i {
color: #b2b1b1;
font-size: 23px;
transition: 0.9s;
}
.trash-container .circle-send:before {
content: '';
width: 40px;
height: 40px;
border-radius: 50%;
opacity: 0.2;
z-index: -1;
position: absolute;
}
@keyframes bounce {
0% {
  transform: scale(1);
}
25% {
  transform: scale(1.4);
}
75% {
  transform: scale(1);
}
100% {
  transform: scale(1.3);
}
}
</style>